/**
 * Wize Mobile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentMobileInputFormRequest { 
    accountId: string;
    orderDate: string;
    defferedExecutionDate?: string;
    analyticalCodeTypeId?: string;
    beneficiaryAmount: number;
    beneficiaryCurrencyId: string;
    chargesRuleValue: PaymentMobileInputFormRequest.ChargesRuleValueEnum;
    beneficiaryAccountTypeValue: PaymentMobileInputFormRequest.BeneficiaryAccountTypeValueEnum;
    beneficiaryAccount: string;
    beneficiarySwiftBicCodeId?: string;
    beneficiaryABARoutingNumber?: string;
    beneficiaryName: string;
    beneficiaryBankName?: string;
    beneficiaryAddress?: string;
    beneficiaryStreet?: string;
    beneficiaryStreet2?: string;
    beneficiaryStreetNumber?: string;
    beneficiaryPostalCode?: string;
    beneficiaryTown?: string;
    beneficiaryCommunications?: string;
    debitMovementDescription?: string;
    beneficiaryCountryId: string;
}
export namespace PaymentMobileInputFormRequest {
    export const ChargesRuleValueEnum = {
        TO_ORDERING_PARTY: 'TO_ORDERING_PARTY',
        TO_BENEFICIARY: 'TO_BENEFICIARY',
        SHARED: 'SHARED'
    } as const;
    export type ChargesRuleValueEnum = typeof ChargesRuleValueEnum[keyof typeof ChargesRuleValueEnum];
    export const BeneficiaryAccountTypeValueEnum = {
        IBAN_ACCOUNT: 'IBAN_ACCOUNT',
        BANK_ACCOUNT: 'BANK_ACCOUNT',
        POST_ACCOUNT: 'POST_ACCOUNT',
        INTERNAL_ACCOUNT: 'INTERNAL_ACCOUNT',
        ABA_FEDWIRE_ACCOUNT: 'ABA_FEDWIRE_ACCOUNT'
    } as const;
    export type BeneficiaryAccountTypeValueEnum = typeof BeneficiaryAccountTypeValueEnum[keyof typeof BeneficiaryAccountTypeValueEnum];
}


